var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"EditorModeControls"},[_c('a-button-group',_vm._l((_vm.modes),function(ref){
var key = ref.key;
var label = ref.label;
var icon = ref.icon;
return _c('a-tooltip',{key:key,attrs:{"title":label}},[_c('a-button',_vm._b({attrs:{"type":(_vm.editorMode === key && 'primary') || undefined},on:{"click":function($event){_vm.editorMode = key}}},'a-button',{ icon: icon },false))],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }